import logo from '/logo.svg'
import type { PropsWithChildren, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { AUTH_CLASSES } from '../authTheme'
import { config } from '../../../config'

type AuthCardLayoutProps = PropsWithChildren<{
  title: string
  description?: ReactNode
}>

/**
 * The frame the signed-out screens besides Login share — page background, header and a single
 * centred card, after patient-web-v2's `AuthLayout`. Login keeps its own two-column hero.
 */
export function AuthCardLayout({ title, description, children }: AuthCardLayoutProps) {
  return (
    <div
      className={`flex min-h-screen w-full flex-col ${AUTH_CLASSES.loginPageBg} ${AUTH_CLASSES.fontScope}`}
    >
      <header className="flex items-center justify-between px-8 py-5 max-[700px]:px-5 max-[700px]:py-4">
        <Link to="/">
          <img src={logo} alt="beHuman" className="block h-9 max-[700px]:h-7" />
        </Link>
        <p className={`m-0 text-[13.5px] ${AUTH_CLASSES.mutedText}`}>
          Need help?{' '}
          <a
            href={`${config.marketingSiteUrl}/contact`}
            className={`font-medium ${AUTH_CLASSES.accentLink}`}
          >
            Contact us
          </a>
        </p>
      </header>

      <main className="flex flex-1 justify-center px-6 pt-10 pb-20 max-[480px]:px-4 max-[480px]:pt-6">
        <div className="h-fit w-full max-w-[520px] rounded-[28px] bg-white p-10 shadow-[0_8px_48px_rgba(0,0,0,0.13)] max-sm:px-6 max-sm:py-8">
          <p
            className={`mb-3 text-[11px] font-bold tracking-[0.12em] uppercase ${AUTH_CLASSES.accentText}`}
          >
            Provider Portal
          </p>
          <h1
            className={`mb-2 text-[32px] leading-[1.2] text-[#1a1a1a] max-[480px]:text-[24px] ${AUTH_CLASSES.serifText}`}
          >
            {title}
          </h1>
          {description && (
            <p className={`mb-9 text-[14px] leading-relaxed ${AUTH_CLASSES.secondaryText}`}>
              {description}
            </p>
          )}
          {children}
        </div>
      </main>
    </div>
  )
}
